export class InvalidFrameEncoding extends Error
{
}

export class IncompatibleRecordFieldNames extends Error
{
}

export class NoSuchField extends Error
{
}

export class InvalidRowIndex extends Error
{
}

export class InvalidColumnOffset extends Error
{
}

export class InvalidFramePath extends Error
{
}

export type NoSuchColumn = null;
export type NoSuchCell = null;
